import React from 'react';
import './software-filter-button.scss';

function SoftwareFilterButton({
  children,
  sort,
  colorCategory,
  selected,
  ...otherProps
}) {
  if (colorCategory === 'tanks-terminals') {
    colorCategory = 'tanks';
  }
  const isSelected = otherProps['data-category'] == selected;
  console.log('otherProps isSelected', isSelected);
  // ${otherProps['data-category'] === selected? "selected":''}
  return (
    <button
      {...otherProps}
      className={`custom-background transparent software-filter-button ${
        isSelected ? 'software-filter-button-selected' : ''
      }`}>
      {children}
    </button>
  );
}

export default SoftwareFilterButton;
